/* =============================================
   jordianali.js — Custom JS
   ============================================= */

/* ── Hero parallax: applies to any .hero with data-jordianali-parallax ──
   - Sets the hero's <img> as a backgroundImage on .hero__media-wrapper
     so it can move with parallax while the original <img> is hidden via CSS.
   - Each .hero__parallax-layer translates relative to the hero's own
     position in the viewport (not window.scrollY) so multiple heroes work.
   - Respects prefers-reduced-motion. */

(function () {
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var heroes = document.querySelectorAll('.hero[data-jordianali-parallax]');
  if (!heroes.length) return;

  // 1) Promote <img> to wrapper background so opacity:0 on .hero__media works
  heroes.forEach(function (hero) {
    var wrapper = hero.querySelector('.hero__media-wrapper');
    var img = hero.querySelector('.hero__media');
    if (!wrapper || !img) return;
    function assignBg() {
      var src = img.currentSrc || img.src;
      if (src) wrapper.style.backgroundImage = 'url(' + src + ')';
    }
    if (img.complete) assignBg(); else img.addEventListener('load', assignBg);
  });

  if (prefersReduced) return;

  // 2) Per-hero parallax for layers (relative to hero position)
  var ticking = false;
  function update() {
    heroes.forEach(function (hero) {
      var rect = hero.getBoundingClientRect();
      // progress: 0 when hero top hits viewport bottom, ~1 when hero bottom leaves viewport top
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var progress = (vh - rect.top) / (vh + rect.height);
      progress = Math.max(0, Math.min(1, progress));
      var layers = hero.querySelectorAll('.hero__parallax-layer');
      layers.forEach(function (layer) {
        var speed = parseFloat(layer.dataset.parallaxSpeed) || 0;
        // Range ≈ ±speed * 30px for a smooth, visible-but-not-extreme effect
        var offset = (progress - 0.5) * speed * 30;
        layer.style.transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0)';
      });
    });
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
